import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
  Collapse,
  TableFooter,
  IconButton,
  Box,
  Paper,
  TablePagination,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import React, { useEffect, useState, Fragment } from "react";
import Container from "src/layout/Container";
import Axios from "axios";
import IsMountedRef from "src/utils/IsMountedRef";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Search from "@material-ui/icons/Search";
import Notify from "src/notification/Notify";

const DeliveredProducts = () => {
  const token = localStorage.getItem("token");
  const management_id = localStorage.getItem("management_id");
  const mounted = IsMountedRef();
  const [drProducts, setDRProducts] = useState({ data: [], ready: false });
  const [drProductsDetails, setDRProductsDetails] = useState({
    data: [],
    ready: false,
  });
  const [selectedProduct, setSelectedAccount] = useState({});
  let totalDrAmount = 0;

  const [query, setQuery] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const getDRProductsByDrNumber = React.useCallback(async () => {
    let response = await Axios.get(
      "pharmacy/warehouse/delivered/drproduct-list",
      {
        params: {
          management_id: management_id,
          token: token,
        },
      }
    );

    let result = response.data;
    if (mounted.current) {
      setDRProducts({ data: result, ready: true });
    }
  }, [management_id, token, mounted]);

  const getDRNumberProductDetails = async (data) => {
    if (selectedProduct.id === data.id) {
      console.log("selected item duplicated");
      return;
    }

    let response = await Axios.get(
      "pharmacy/warehouse/delivered/drnumber-details",
      {
        params: {
          management_id: management_id,
          token: token,
          dr_number: data.dr_number,
        },
      }
    );

    let result = response.data;
    if (mounted.current) {
      setDRProductsDetails({ data: result, ready: true });
    }
  };

  const calculateTotal = (total) => {
    totalDrAmount += parseFloat(total);
    return total;
  };

  const handleSearch = (event) => {
    event.persist();
    setQuery(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const filteredProducts = searchDrProduct(drProducts, query);
  const paginatedProducts = applyPagination(filteredProducts, page, limit);

  useEffect(() => {
    getDRProductsByDrNumber();
  }, [getDRProductsByDrNumber]);

  return (
    <Container
      breadcrumbs={{
        enable: true,
        current: "delivery",
        items: [{ name: "Dashboard", path: "/clinic/app/warehouse" }],
      }}
      title={"List Of Delivery"}
    >
      <Paper>
        <Box p={2}>
          <Box display="flex" justifyContent="flex-end" mb={1}>
            <Box>
              <TextField
                fullWidth
                label="Search DR Number"
                variant="outlined"
                onChange={handleSearch}
                value={query}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <Search color="primary" />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell> Date </TableCell>
                  <TableCell> DR Number </TableCell>
                  <TableCell> Account </TableCell>
                  <TableCell> Product </TableCell>
                  <TableCell> Generic </TableCell>
                  <TableCell> Unit </TableCell>
                  <TableCell> Total </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {drProducts.ready ? (
                  paginatedProducts.length > 0 ? (
                    paginatedProducts.map((data, index) => (
                      <Fragment key={index}>
                        <TableRow>
                          <TableCell>
                            <IconButton
                              onClick={() => {
                                setSelectedAccount(data);
                                getDRNumberProductDetails(data);
                              }}
                              color={"primary"}
                            >
                              {selectedProduct.id === data.id ? (
                                <KeyboardArrowUpIcon />
                              ) : (
                                <KeyboardArrowDownIcon />
                              )}
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            {Notify.createdAt(data.dr_date)}
                          </TableCell>
                          <TableCell> {data.dr_number} </TableCell>
                          <TableCell> {data.dr_accountname} </TableCell>
                          <TableCell> {data.product_name} </TableCell>
                          <TableCell> {data.product_generic} </TableCell>
                          <TableCell> {data.unit} </TableCell>
                          <TableCell align="right">
                            {Notify.convertToNumber(
                              calculateTotal(data.dr_totalamount)
                            )}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell colSpan={10} style={{ border: 0 }}>
                            <Collapse
                              in={selectedProduct.id === data.id}
                              timeout="auto"
                              unmountOnExit
                            >
                              <Box margin={1}>
                                <Typography
                                  variant="h6"
                                  gutterBottom
                                  component={Box}
                                  flexGrow={1}
                                  color="textSecondary"
                                >
                                  Batches List
                                </Typography>

                                <Table>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell> Product </TableCell>
                                      <TableCell> Unit </TableCell>
                                      <TableCell> Mfg Date </TableCell>
                                      <TableCell> Exp. Date </TableCell>
                                      <TableCell> Batch Number </TableCell>
                                      <TableCell> Qty </TableCell>
                                      <TableCell> Srp </TableCell>
                                      <TableCell> Amount </TableCell>
                                    </TableRow>
                                  </TableHead>

                                  <TableBody>
                                    {drProductsDetails.ready ? (
                                      drProductsDetails.data.length > 0 ? (
                                        drProductsDetails.data.map(
                                          (xdata, xindex) => (
                                            <TableRow key={xindex}>
                                              <TableCell>
                                                {xdata.product_name}
                                              </TableCell>
                                              <TableCell>
                                                {xdata.unit}
                                              </TableCell>
                                              <TableCell>
                                                {xdata.expiration_date}
                                              </TableCell>
                                              <TableCell>
                                                {xdata.manufactured_date}
                                              </TableCell>
                                              <TableCell>
                                                {xdata.dr_number}
                                              </TableCell>
                                              <TableCell align="center">
                                                {xdata.qty}
                                              </TableCell>
                                              <TableCell align="center">
                                                {xdata.srp}
                                              </TableCell>
                                              <TableCell align="center">
                                                {xdata.srp * xdata.qty}
                                              </TableCell>
                                            </TableRow>
                                          )
                                        )
                                      ) : (
                                        <TableRow>
                                          <TableCell colSpan={8}>
                                            <Typography color="secondary">
                                              No record found.
                                            </Typography>
                                          </TableCell>
                                        </TableRow>
                                      )
                                    ) : (
                                      <TableRow>
                                        <TableCell colSpan={8}>
                                          <Typography color="primary">
                                            please wait...
                                          </Typography>
                                        </TableCell>
                                      </TableRow>
                                    )}
                                  </TableBody>
                                </Table>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </Fragment>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10}>
                        <Typography color="secondary">
                          No record found.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )
                ) : (
                  <TableRow>
                    <TableCell colSpan={10}>
                      <Typography color="primary">
                        loading, please wait...
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>

              <TableFooter>
                <TableRow>
                  <TableCell colSpan={6} />
                  <TableCell align="center"> Total DR Amount: </TableCell>
                  <TableCell align="right">
                    {Notify.convertToNumber(totalDrAmount)}
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>

            <TablePagination
              component={"div"}
              count={filteredProducts.length}
              labelRowsPerPage="List"
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleLimitChange}
              page={page}
              rowsPerPage={limit}
              rowsPerPageOptions={[10, 50, 100]}
            />
          </TableContainer>
        </Box>
      </Paper>
    </Container>
  );
};

export default DeliveredProducts;

const searchDrProduct = (delivery, query) => {
  return delivery.data.filter((xdata) => {
    let matches = true;

    if (query) {
      let containsQuery = false;

      if (xdata.dr_number.toLowerCase().includes(query.toLowerCase())) {
        containsQuery = true;
      }

      if (!containsQuery) {
        matches = false;
      }
    }
    return matches;
  });
};

const applyPagination = (clinic, page, limit) => {
  return clinic.slice(page * limit, page * limit + limit);
};
